export function openBlobInNewTab(documentTab: Window, blob: Blob): void {
  const objectUrl = URL.createObjectURL(blob);
  try {
    documentTab.location.href = objectUrl;
  } catch (error) {
    URL.revokeObjectURL(objectUrl);
    throw error;
  }

  const closeCheck = window.setInterval(() => {
    if (!documentTab.closed) return;

    window.clearInterval(closeCheck);
    URL.revokeObjectURL(objectUrl);
  }, 1000);
}
